import { put, takeLatest } from "@redux-saga/core/effects";
import MessageComponent from "components/Message/Message";
import { Notification } from "components/Notification/Noti";
import { FE_URL } from "constants/constants";
import {
  createServiceAPI,
  deleteServiceAPI,
  getArticleDetailAPI,
  getListArticleSearchAPI,
  getNewestAPI,
  getTopViewAPI,
  loadArticleDashboardAPI,
  loadListCategoryAPI,
  reIndexAPI,
  syncDataAPI,
  testConnectionAPI,
  updateServiceAPI,
} from "redux/api/enhancementViewAPI";

import { loadFieldsAPI } from "redux/api/knowledgeEnhancementAPI";
import {
  getListArticleDashboardSuccess,
  getListCategory,
  getListCategorySuccess,
  getListFieldObject,
  getListArticleDashboard,
  getListFieldObjectSuccess,
  getTopviewSuccess,
  getNewestSuccess,
  getTopview,
  getNewest,
  getListArticleSearchSuccess,
  getListArticleSearch,
  getArticleDetailSuccess,
  getArticleDetail,
  getListArticleFilterSuccess,
  getListArticleFilter,
  createService,
  createCategory,
  updateArticle,
  updateCategory,
  deleteCategory,
  deleteArticle,
  syncData,
  testConnection,
  reIndex,
  updateIsConfirm,
} from "redux/slices/enhancementView";
import { setShowLoadingScreen } from "redux/slices/global";

export default function* enhancementViewSaga() {
  yield takeLatest(getListFieldObject.type, getListFieldObjectSaga);
  yield takeLatest(getListCategory.type, getListCategorySaga);
  yield takeLatest(getListArticleDashboard.type, getListArticleDashboardSaga);
  yield takeLatest(getTopview.type, getTopViewSaga);
  yield takeLatest(getNewest.type, getNewstSaga);
  yield takeLatest(getListArticleSearch.type, getListArticleSearchSaga);
  yield takeLatest(getArticleDetail.type, getArticleDetailSaga);
  yield takeLatest(getListArticleFilter.type, getListArticleFilterSaga);
  yield takeLatest(createService.type, createServiceSaga);
  yield takeLatest(createCategory.type, createCategorySaga);
  yield takeLatest(updateArticle.type, updateServiceSaga);
  yield takeLatest(updateCategory.type, updateCateggorySaga);
  yield takeLatest(deleteCategory.type, deleteCateggorySaga);
  yield takeLatest(deleteArticle.type, deleteArticleSaga);
  yield takeLatest(syncData.type, syncDataSaga);
  yield takeLatest(testConnection.type, testConnectionSaga);
  yield takeLatest(reIndex.type, reIndexSaga);
}

function* getListFieldObjectSaga(action) {
  try {
    const { data } = yield loadFieldsAPI(action.payload);
    yield put(getListFieldObjectSuccess(data.data));
  } catch (error) {
    Notification("error", error.response.data.error);
  }
}

function* getListCategorySaga(action) {
  try {
    const { data } = yield loadListCategoryAPI(action.payload);
    yield put(getListCategorySuccess(data.data));
  } catch (error) {
    Notification("error", error.response.data.error);
  }
}

function* getListArticleDashboardSaga(action) {
  try {
    yield put(setShowLoadingScreen(true));
    const { data } = yield loadArticleDashboardAPI(action.payload);
    yield put(getListArticleDashboardSuccess(data.data));
    yield put(setShowLoadingScreen(false));
  } catch (error) {
    yield put(setShowLoadingScreen(false));
    Notification("error", error.response.data.error);
  }
}

function* getTopViewSaga(action) {
  try {
    const { data } = yield getTopViewAPI(action.payload);
    yield put(getTopviewSuccess(data.data));
  } catch (error) {
    Notification("error", error.response.data.error);
  }
}

function* getNewstSaga(action) {
  try {
    const { data } = yield getNewestAPI(action.payload);
    yield put(getNewestSuccess(data.data));
  } catch (error) {
    Notification("error", error.response.data.error);
  }
}

function* getListArticleSearchSaga(action) {
  try {
    yield put(setShowLoadingScreen(true));
    const { data } = yield getListArticleSearchAPI(action.payload);
    yield put(getListArticleSearchSuccess(data.data));
    yield put(setShowLoadingScreen(false));
  } catch (error) {
    yield put(setShowLoadingScreen(false));
    Notification("error", error.response.data.error);
  }
}

function* getArticleDetailSaga(action) {
  try {
    // yield put(setShowLoadingScreen(true));
    const { data } = yield getArticleDetailAPI(action.payload);
    yield put(getArticleDetailSuccess(data.data));
    // yield put(setShowLoadingScreen(false));
  } catch (error) {
    // yield put(setShowLoadingScreen(false));
    Notification("error", error.response.data.error);
  }
}

function* getListArticleFilterSaga(action) {
  try {
    yield put(setShowLoadingScreen(true));
    const { data } = yield getListArticleSearchAPI(action.payload);
    yield put(getListArticleFilterSuccess(data.data));
    yield put(setShowLoadingScreen(false));
  } catch (error) {
    yield put(setShowLoadingScreen(false));
    Notification("error", error.response.data.error);
  }
}

function* createServiceSaga(action) {
  try {
    yield put(updateIsConfirm(false));
    const { data } = yield createServiceAPI(action.payload);
    if (action.payload.auto) {
      window.open(
        `${FE_URL}/knowledge-base-enhancement/edit-article/${
          action.payload.object_id
        }/${data.data.slug || data.data._id}`,
        "_self"
      );
    } else if (action.payload.duplicate) {
      MessageComponent("Duplicate article success");
      window.open(
        `${FE_URL}/knowledge-base-enhancement/edit-article/${
          action.payload.object_id
        }/${data.data.slug || data.data._id}`
      );
    } else {
      MessageComponent("Add article success");
      // Notification("success", "Add article success");
      setTimeout(() => {
        window.open(
          `${FE_URL}/knowledge-base-enhancement/details/${
            action.payload.object_id
          }/${data.data.slug || data.data._id}`,
          "_self"
        );
      }, 1000);
    }
  } catch (error) {
    Notification("error", error.response.data.error);
  }
}

function* updateServiceSaga(action) {
  try {
    const { data } = yield updateServiceAPI(action.payload);
    console.log("data", data);
    if (action.payload.auto) {
      MessageComponent("Saved");
      setTimeout(() => {
        window.open(
          `${FE_URL}/knowledge-base-enhancement/details/${
            action.payload.object_id
          }/${data.data?.slug || action.payload.data.record_id}`,
          "_self"
        );
      }, 1000);
    } else {
      yield put(updateIsConfirm(false));
      MessageComponent("Update article success");
      setTimeout(() => {
        window.open(
          `${FE_URL}/knowledge-base-enhancement/details/${
            action.payload.object_id
          }/${data.data?.slug || action.payload.data.record_id}`,
          "_self"
        );
      }, 1000);
    }
  } catch (error) {
    Notification("error", error.response.data.error);
  }
}

function* createCategorySaga(action) {
  try {
    yield createServiceAPI(action.payload);
    MessageComponent("Create category success");
    // Notification("success", "Create category success");
    yield put(getListCategory(action.payload));
  } catch (error) {
    Notification("error", error.response.data.error);
  }
}

function* updateCateggorySaga(action) {
  try {
    yield updateServiceAPI(action.payload);
    MessageComponent("Update category success");
    // Notification("success", "Update category success");
    yield put(getListCategory(action.payload));
  } catch (error) {
    Notification("error", error.response.data.error);
  }
}

function* deleteCateggorySaga(action) {
  try {
    yield deleteServiceAPI(action.payload);
    MessageComponent("Delete category success");
    // Notification("success", "Delete category success");
    yield put(getListCategory(action.payload));
  } catch (error) {
    Notification("error", error.response.data.error);
  }
}

function* deleteArticleSaga(action) {
  try {
    yield deleteServiceAPI(action.payload.data);
    MessageComponent("Delete article success");
    // Notification("success", "Delete article success");
    setTimeout(() => {
      if (action.payload.is_document) {
        window.open(
          `${FE_URL}/knowledge-base-enhancement/details/${action.payload.data.object_id}`,
          "_self"
        );
      } else {
        window.open(
          `${FE_URL}/knowledge-base-enhancement/${action.payload.data.object_id}/search`,
          "_self"
        );
      }
    }, 1000);
  } catch (error) {
    Notification("error", error.response.data.error);
  }
}

function* syncDataSaga(action) {
  try {
    yield syncDataAPI(action.payload);
    Notification("success", "Sync data success");
  } catch (error) {
    Notification("error", error.response.data.error);
  }
}

function* testConnectionSaga(action) {
  try {
    yield testConnectionAPI(action.payload);
    Notification("success", "Success");
  } catch (error) {
    Notification("error", error.response.data.error);
  }
}

function* reIndexSaga(action) {
  try {
    yield reIndexAPI(action.payload);
    Notification("success", "Re-index success");
  } catch (error) {
    Notification("error", error.response.data.error);
  }
}
